 class LookbookWithShowAll extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            this.showBtn = this.querySelector('[data-show-btn]');
            this.hideBtn = this.querySelector('[data-hide-btn]');
            this.lookbookShowAllCloseBtn = this.querySelector('[data-lookbook-show-all-close]');
            this.lookbookImage = this.querySelector('[data-lookbook-image]');
            this.showBtn?.addEventListener('click', this.toggleShowAll.bind(this));
            this.lookbookShowAllCloseBtn?.addEventListener('click', this.toggleShowAll.bind(this));
        }
        toggleShowAll(e) {
            const button = e.currentTarget;
            this.lookbookImage.classList.toggle('show-all-products', button.hasAttribute('data-show-btn'));
        }
    }
    customElements.define('lookbook-with-show-all', LookbookWithShowAll);